import attach from './assets/attach.svg';
import attached from './assets/attached.svg';
import crop from './assets/crop.svg';
import conveyorSelected from './assets/conveyorSelected.svg';
import tag from './assets/tag.svg';
import tagSelected from './assets/tagSelected.svg';
import smartIcon from './assets/SmartIcon.svg';
import smartFactory from './assets/SmartFactory.svg';
import chevronRightLight from './assets/chevronRightLight.svg';
import chevronRight from './assets/chevronRight.svg';
import chevronLeft from './assets/chevronLeft.svg';
import burger from './assets/burger.svg';
import selected from './assets/selected.svg';
import unselected from './assets/unselected.svg';
import settings from './assets/settings.svg';
import camera from './assets/camera.svg';
import picture from './assets/picture.svg';
import file from './assets/file.svg';
import files from './assets/files.svg';
import filesSelected from './assets/filesSelected.svg';
import squares from './assets/squares.svg';
import plus from './assets/plus.svg';
import more from './assets/more.svg';
import arrow from './assets/arrow.svg';
import cloud from './assets/cloud.svg';
import compareVersions from './assets/Compare.svg';
import compareVersionsDark from './assets/compare-black.svg';
import gallery from './assets/gallery.svg';
import starSelected from './assets/starSelected.svg';
import starUnselected from './assets/starUnselected.svg';
import exclamationCircle from './assets/exclamationCircle.svg';
import times from './assets/times.svg';
import backspace from './assets/backspace.svg';
import cog from './assets/cog.svg';
import upload from './assets/upload.svg';
import share from './assets/share.svg';
import info from './assets/info.svg';
import folder from './assets/folder.svg';
import remove from './assets/delete.svg';
import link from './assets/link.svg';
import rotate from './assets/rotate.svg';
import minus from './assets/minus.svg';
import plusSmall from './assets/plusSmall.svg';
import refresh from './assets/refresh.svg';
import qr from './assets/qr.svg';
import menuCogSelected from './assets/menuCogSelected.svg';
import productionOrderSelected from './assets/productionOrderSelected.svg';
import productionOrderUnselected from './assets/productionOrderUnselected.svg';
import machineSelected from './assets/machineSelected.svg';
import machineUnselected from './assets/machineUnselected.svg';
import check from './assets/check.svg';
import ellipsis from './assets/ellipsis.svg';
import editCircle from './assets/editCircle.svg';
import editCircleSelected from './assets/editCircleSelected.svg';
import close from './assets/close.svg';
import theme from './assets/theme.svg';
import operated from './assets/operated.svg';
import S from './assets/S.svg';
import i from './assets/i.svg';
import machineLink from './assets/machineLink.svg';
import machineIgnored from './assets/machineIgnored.svg';
import error from './assets/error.svg';
import machineIgnoredSmall from './assets/machineIgnoredSmall.svg';
import chevronBottomLight from './assets/chevronBottomLight.svg';
import chevronUp from './assets/chevronUp.svg';
import cameraBig from './assets/cameraBig.svg';
import unknownNC from './assets/unknownNC.svg';
import machineLinkSmall from './assets/machineLinkSmall.svg';
import edit from './assets/edit.svg';
import ok from './assets/ok.svg';
import notSetupYet from './assets/notSetupYet.svg';
import updating from './assets/updating.svg';
import errorBig from './assets/errorBig.svg';
import stopped from './assets/stopped.svg';
import off from './assets/off.svg';
import partsUnselected from './assets/partsUnselected.svg';
import partsSelected from './assets/partsSelected.svg';
import NCFileSelected from './assets/NCFileSelected.svg';
import NCFileUnselected from './assets/NCFileUnselected.svg';
import search from './assets/search.svg';
import tick from './assets/tick.svg';
import addPicture from './assets/addPicture.svg';
import greyArrow from './assets/greyArrow.svg';
import cropRotate from './assets/cropRotate.svg';
import operatorPanel from './assets/operatorPanel.svg';
import closeOperatorPanel from './assets/closeOperatorPanel.svg';
import zzz from './assets/zzz.svg';
import uploadBig from './assets/uploadBig.svg';
import addPictureBig from './assets/addPictureBig.svg';
import searchSelected from './assets/searchSelected.svg';
import tagSelectedPreview from './assets/tagSelectedPreview.svg';
import collapse from './assets/collapse.svg';
import expand from './assets/expand.svg';
import expandView from './assets/expandView.svg';
import zoom from './assets/zoom.svg';
import zoomOut from './assets/zoomOut.svg';
import togo from './assets/togo.svg';
import sidePanel from './assets/sidePanel.svg';
import filter from './assets/filter.svg';
import fullItem from './assets/fullItem.svg';
import pdf from './assets/pdf.svg';
import connecting from './assets/connecting.svg';
import bigArrow from './assets/bigArrow.svg';
import noConnector from './assets/noConnector.svg';
import connectorOff from './assets/connectorOff.svg';
import tileSize from './assets/tileSize.svg';
import download from './assets/download.svg';
import reload from './assets/reload.svg';
import changeActive from './assets/changeActive.svg';
import changeInactive from './assets/changeInactive.svg';
import linkedInactive from './assets/linkedInactive.svg';
import linkedActive from './assets/linkedActive.svg';
import ignoreActive from './assets/ignoreActive.svg';
import ignoreInactive from './assets/ignoreInactive.svg';
import noConnectorLarge from './assets/noConnectorLarge.svg';
import machineConnectionOffLarge from './assets/machineConnectionOffLarge.svg';
import connectorOfflineLarge from './assets/connectorOfflineLarge.svg';
import ncFileActive from './assets/ncFileActive.svg';
import ncFileChange from './assets/ncFileChange.svg';
import ncFileNotProductive from './assets/ncFileNotProductive.svg';
import ncFileUnknown from './assets/ncFileUnknown.svg';
import exclamationMark from './assets/exclamationMark.svg';
import statusesLine from './assets/statusesLine.svg';
import closeBold from './assets/closeBold.svg';
import clip from './assets/clip.svg';
import home from './assets/home.svg';
import history from './assets/history.svg';
import ncFileSearchHistory from './assets/ncFileSearchHistory.svg';
import line from './assets/line.svg';
import machine from './assets/machine.svg';
import user from './assets/user.svg';
import phone from './assets/phone.svg';
import addMenu from './assets/addMenu.svg';
import addMenuSelected from './assets/addMenuSelected.svg';
import clear from './assets/clear.svg';
import apple from './assets/apple.svg';
import android from './assets/android.svg';
import AccountSettingsIcon from './assets/AccountSettingsIcon.svg';
import APIKeysSettingsIcon from './assets/APIKeysSettingsIcon.svg';
import ImnooSettingsIcon from './assets/ImnooSettingsIcon.svg';
import CompanySettingsIcon from './assets/CompanySettingsIcon.svg';
import ConnectorSettingsIcon from './assets/ConnectorSettingsIcon.svg';
import DevicesSettingsIcon from './assets/DevicesSettingsIcon.svg';
import SupportSettingsIcon from './assets/SupportSettingsIcon.svg';
import MachinesSettingsIcon from './assets/MachinesSettingsIcon.svg';
import NotificationsSettingsIcon from './assets/NotificationsSettingsIcon.svg';
import PowerBISettingsIcon from './assets/PowerBISettingsIcon.svg';
import UsersSettingsIcon from './assets/UsersSettingsIcon.svg';
import SmartFactoryFill from './assets/SmartFactoryFill.svg';
import themeLight from './assets/themeLight.svg';
import themeDark from './assets/themeDark.svg';
import themeSystem from './assets/themeSystem.svg';
import OEEArrow from './assets/OEEArrow.svg';
import calendar from './assets/calendar.svg';
import columns from './assets/columns.svg';
import filters from './assets/filters.svg';
import densityStandard from './assets/densityStandard.svg';
import densityCompact from './assets/densityCompact.svg';
import exportData from './assets/exportData.svg';
import triangle from './assets/triangle.svg';
import zoomInGlass from './assets/zoomInGlass.svg';
import zoomOutGlass from './assets/zoomOutGlass.svg';
import zoomResetGlass from './assets/zoomResetGlass.svg';
import cameraPlus from './assets/cameraPlus.svg';
import coins from './assets/coins.svg';
import cogWithBackground from './assets/cogWithBackground.svg';
import crossedBell from './assets/crossedBell.svg';
import loopedArrows from './assets/loopedArrows.svg';
import updown from './assets/updown.svg';
import runningMan from './assets/runningMan.svg';
import fastForward from './assets/fastForward.svg';
import hourglass from './assets/hourglass.svg';
import checkboxGrey from './assets/checkboxGrey.svg';
import readyToRunMan from './assets/readyToRunMan.svg';
import divider from './assets/divider.svg';
import circledCheck from './assets/circledCheck.svg';
import circledExclamationMark from './assets/circledExclamationMark.svg';
import finishFlag from './assets/finishFlag.svg';
import linked from './assets/linked.svg';
import linkArrow from './assets/linkArrow.svg';
import xMark from './assets/xMark.svg';
import batchPaid from './assets/batchPaid.svg';
import batchActual from './assets/batchActual.svg';
import batchIdeal from './assets/batchIdeal.svg';
import linkedJobs from './assets/linkedJobs.svg';
import jobsList from './assets/jobsList.svg';
import jobsListSelected from './assets/jobsListSelected.svg';
import arrowCircle from './assets/arrowCircle.svg';
import lineChart from './assets/lineChart.svg';
import barChart from './assets/barChart.svg';
import multiLink from './assets/multiLink.svg';
import notLinked from './assets/notLinked.svg';
import halfLink from './assets/halfLink.svg';
import unknown from './assets/unknown.svg';
import change from './assets/change.svg';
import ignore from './assets/ignore.svg';
import notTagged from './assets/notTagged.svg';
import image from './assets/image.svg';
import document from './assets/document.svg';
import idealTime from './assets/idealTime.svg';
import standardList from './assets/standardList.svg';
import compactList from './assets/compactList.svg';
import uploadCircle from './assets/uploadCircle.svg';
import machineConnectionOff from './assets/machineConnectionOff.svg';
import markdown from './assets/markdown.svg';
import markdownIcon from './assets/markdownIcon.svg';
import chevronBottom from './assets/chevronBottom.svg';
import unknownLink from './assets/unknownLink.svg';
import scheduledTime from './assets/scheduledTime.svg';
import pause from './assets/pause.svg';
import radioButton from './assets/radioButton.svg';
import runningBunny from './assets/runningBunny.svg';
import euro from './assets/euro.svg';
import middleArrow from './assets/middleArrow.svg';
import ncFileLinked from './assets/ncFileLinked.svg';
import clampingImage from './assets/clampingImage.svg';
import material from './assets/material.svg';
import measurements from './assets/measurements.svg';
import measurementsSelected from './assets/measurementsSelected.svg';
import other from './assets/other.svg';
import partImage from './assets/partImage.svg';
import partImageSelected from './assets/partImageSelected.svg';
import productionOrder from './assets/productionOrder.svg';
import salesOrder from './assets/salesOrder.svg';
import setup from './assets/setup.svg';
import setupActive from './assets/setupActive.svg';
import setupInactive from './assets/setupInactive.svg';
import plusWithCircle from './assets/plusWithCircle.svg';
import setupSelected from './assets/setupSelected.svg';
import threeDDrawing from './assets/threeDDrawing.svg';
import twoDDrawing from './assets/twoDDrawing.svg';
import clipMinus from './assets/clipMinus.svg';
import arrowLight from './assets/arrowLight.svg';
import activeMachine from './assets/activeMachine.svg';
import changeMachine from './assets/changeMachine.svg';
import setupMachine from './assets/setupMachine.svg';
import infoTilesView from './assets/infoTilesView.svg';
import clock from './assets/clock.svg';
import square from './assets/square.svg';
import userWithClock from './assets/userWithClock.svg';
import crossedBellDynamicColor from './assets/crossedBellDynamicColor.svg';
import infoFilled from './assets/infoFilled.svg';
import sendToMachine from './assets/sendToMachine.svg';
import walkingMan from './assets/walkingMan.svg';
import qrCode from './assets/qrCode.svg';
import language from './assets/language.svg';
import appearance from './assets/appearance.svg';
import textSize from './assets/textSize.svg';
import tools from './assets/tools.svg';
import toolsSelected from './assets/toolsSelected.svg';
import actual from './assets/actual.svg';
import chevronRegular from './assets/chevronRegular.svg';
import save from './assets/save.svg';
import skipped from './assets/skipped.svg';
import dotsClock from './assets/dotsClock.svg';
import machineOff from './assets/machineOff.svg';
import noConnectionPossible from './assets/noConnectionPossible.svg';
import machineOffline from './assets/machineOffline.svg';
import clipCross from './assets/clipCross.svg';
import rteAlignCenter from './assets/rte_align-center.svg';
import rteAlignLeft from './assets/rte_align-left.svg';
import rteAlignRight from './assets/rte_align-right.svg';
import rteBold from './assets/rte_bold.svg';
import rteImage from './assets/rte_image.svg';
import rteItalic from './assets/rte_italic.svg';
import rteLink from './assets/rte_link.svg';
import rteOrderedList from './assets/rte_ordered-list.svg';
import rteStrikethrough from './assets/rte_strikethrough.svg';
import rteText from './assets/rte_text.svg';
import rteUnderline from './assets/rte_underline.svg';
import rteUnorderedList from './assets/rte_unordered-list.svg';
import threeDDrawingSelected from './assets/threeDDrawingSelected.svg';
import play from './assets/play.svg';
import documentMore from './assets/documentMore.svg';
import linkPlus from './assets/linkPlus.svg';
import docx from './assets/docx.svg';
import xlsx from './assets/xlsx.svg';
import csv from './assets/csv.svg';
import pptx from './assets/pptx.svg';
import xml from './assets/xml.svg';
import msg from './assets/msg.svg';
import dwg from './assets/dwg.svg';
import stl from './assets/stl.svg';
import zip from './assets/zip.svg';
import unknownFileExtension from './assets/unknownFileExtension.svg';
import pictureUnderline from './assets/pictureUnderline.svg';
import linkChain from './assets/linkChain.svg';
import planboardInfo from './assets/planboardInfo.svg';
import fileWithCheckMark from './assets/fileWithCheckMark.svg';
import fileWithPlusMark from './assets/fileWithPlusMark.svg';
import clipCheck from './assets/clipCheck.svg';
import unlink from './assets/unlink.svg';
import clearNCFile from './assets/clearNCFile.svg';
import pin from './assets/pin.svg';
import roundedChevron from './assets/roundedChevron.svg';
import arrowVertical from './assets/arrowVertical.svg';
import pauseOP from './assets/pauseOP.svg';
import startOP from './assets/startOP.svg';
import inTime from './assets/inTime.svg';
import hoursLate from './assets/hoursLate.svg';
import activeLiveScreen from './assets/activeLiveScreen.svg';
import changeLiveScreen from './assets/changeLiveScreen.svg';
import setupLiveScreen from './assets/setupLiveScreen.svg';
import notProductiveLiveScreen from './assets/notProductiveLiveScreen.svg';
import checkCircle from './assets/checkCircle.svg';
import annotations from './assets/annotations.svg';

export default {
  plusWithCircle,
  play,
  attach,
  attached,
  machineOffline,
  noConnectionPossible,
  machineOff,
  scheduledTime,
  compactList,
  unknownLink,
  markdownIcon,
  chevronBottom,
  machineConnectionOff,
  uploadCircle,
  standardList,
  idealTime,
  document,
  image,
  notTagged,
  ignore,
  change,
  unknown,
  notLinked,
  halfLink,
  multiLink,
  lineChart,
  barChart,
  arrowCircle,
  linkedJobs,
  batchPaid,
  batchActual,
  batchIdeal,
  xMark,
  linkArrow,
  linked,
  finishFlag,
  coins,
  cameraPlus,
  calendar,
  OEEArrow,
  SmartFactoryFill,
  AccountSettingsIcon,
  APIKeysSettingsIcon,
  CompanySettingsIcon,
  ConnectorSettingsIcon,
  DevicesSettingsIcon,
  SupportSettingsIcon,
  MachinesSettingsIcon,
  ImnooSettingsIcon,
  NotificationsSettingsIcon,
  PowerBISettingsIcon,
  UsersSettingsIcon,
  apple,
  android,
  addMenu,
  addMenuSelected,
  clear,
  phone,
  user,
  machine,
  line,
  history,
  ncFileSearchHistory,
  home,
  clip,
  clipMinus,
  closeBold,
  statusesLine,
  exclamationMark,
  ncFileUnknown,
  ncFileNotProductive,
  ncFileChange,
  ncFileActive,
  noConnectorLarge,
  machineConnectionOffLarge,
  connectorOfflineLarge,
  ignoreActive,
  ignoreInactive,
  linkedInactive,
  linkedActive,
  changeInactive,
  changeActive,
  reload,
  download,
  tileSize,
  connectorOff,
  noConnector,
  bigArrow,
  connecting,
  pdf,
  fullItem,
  filter,
  sidePanel,
  togo,
  zoomOut,
  zoom,
  collapse,
  expand,
  expandView,
  tagSelectedPreview,
  searchSelected,
  addPictureBig,
  uploadBig,
  zzz,
  closeOperatorPanel,
  operatorPanel,
  cropRotate,
  greyArrow,
  addPicture,
  tick,
  errorBig,
  search,
  partsUnselected,
  partsSelected,
  NCFileSelected,
  NCFileUnselected,
  chevronRight,
  ok,
  stopped,
  off,
  notSetupYet,
  updating,
  edit,
  machineLinkSmall,
  unknownNC,
  cameraBig,
  chevronBottomLight,
  chevronUp,
  machineIgnored,
  machineIgnoredSmall,
  error,
  machineLink,
  S,
  i,
  operated,
  theme,
  close,
  ellipsis,
  check,
  machineSelected,
  machineUnselected,
  menuCogSelected,
  productionOrderSelected,
  productionOrderUnselected,
  qr,
  refresh,
  plusSmall,
  minus,
  gallery,
  cloud,
  compareVersions,
  compareVersionsDark,
  arrow,
  more,
  crop,
  conveyorSelected,
  tag,
  tagSelected,
  smartIcon,
  smartFactory,
  chevronRightLight,
  burger,
  selected,
  unselected,
  settings,
  camera,
  picture,
  file,
  files,
  filesSelected,
  chevronLeft,
  squares,
  plus,
  starSelected,
  starUnselected,
  exclamationCircle,
  times,
  backspace,
  cog,
  upload,
  remove,
  folder,
  info,
  share,
  link,
  rotate,
  themeLight,
  themeDark,
  themeSystem,
  columns,
  filters,
  densityStandard,
  densityCompact,
  exportData,
  triangle,
  zoomInGlass,
  zoomOutGlass,
  zoomResetGlass,
  cogWithBackground,
  crossedBell,
  loopedArrows,
  runningMan,
  fastForward,
  hourglass,
  checkboxGrey,
  readyToRunMan,
  divider,
  circledCheck,
  circledExclamationMark,
  pause,
  radioButton,
  runningBunny,
  euro,
  middleArrow,
  ncFileLinked,
  clampingImage,
  material,
  measurements,
  measurementsSelected,
  other,
  partImage,
  partImageSelected,
  productionOrder,
  salesOrder,
  setup,
  setupActive,
  setupInactive,
  setupSelected,
  threeDDrawing,
  twoDDrawing,
  arrowLight,
  activeMachine,
  changeMachine,
  setupMachine,
  infoTilesView,
  clock,
  square,
  userWithClock,
  crossedBellDynamicColor,
  infoFilled,
  sendToMachine,
  walkingMan,
  qrCode,
  language,
  appearance,
  textSize,
  actual,
  chevronRegular,
  save,
  editCircle,
  editCircleSelected,
  tools,
  toolsSelected,
  jobsList,
  jobsListSelected,
  markdown,
  rteAlignCenter,
  rteAlignLeft,
  rteAlignRight,
  rteBold,
  rteImage,
  rteItalic,
  rteLink,
  rteOrderedList,
  rteStrikethrough,
  rteText,
  rteUnderline,
  rteUnorderedList,
  skipped,
  dotsClock,
  clipCross,
  threeDDrawingSelected,
  documentMore,
  linkPlus,
  docx,
  xlsx,
  csv,
  pptx,
  xml,
  msg,
  dwg,
  stl,
  zip,
  unknownFileExtension,
  pictureUnderline,
  linkChain,
  planboardInfo,
  updown,
  fileWithCheckMark,
  fileWithPlusMark,
  clipCheck,
  unlink,
  clearNCFile,
  pin,
  clearNCFile,
  roundedChevron,
  arrowVertical,
  pauseOP,
  startOP,
  inTime,
  hoursLate,
  activeLiveScreen,
  changeLiveScreen,
  setupLiveScreen,
  notProductiveLiveScreen,
  checkCircle,
  annotations,
};
